import type { MediaItem } from "@/types/media";

export interface FilterOption {
  label: string;
  value: string;
}

export interface FilterGroup {
  key: "category" | "region" | "year" | "sort";
  label: string;
  options: FilterOption[];
}

const sortOptions: FilterOption[] = [
  { label: "最多收藏", value: "default" },
  { label: "最新上线", value: "newest" },
  { label: "评分最高", value: "rating" },
];

export function buildFilterGroups(list: MediaItem[]): FilterGroup[] {
  const toOptions = (values: string[]) =>
    values.map((value) => ({ label: value, value }));

  const categories = Array.from(new Set(list.map((item) => item.category)));
  const regions = Array.from(new Set(list.map((item) => item.region)));
  const years = Array.from(new Set(list.map((item) => item.year))).sort(
    (a, b) => Number(b) - Number(a),
  );

  return [
    { key: "category", label: "类型", options: toOptions(categories) },
    { key: "region", label: "地区", options: toOptions(regions) },
    { key: "year", label: "年份", options: toOptions(years) },
    { key: "sort", label: "排序", options: sortOptions },
  ];
}

export interface FilterState {
  category: string;
  region: string;
  year: string;
  sort: string;
}

export const defaultFilterState: FilterState = {
  category: "all",
  region: "all",
  year: "all",
  sort: "default",
};

export function applyFilter(list: MediaItem[], state: FilterState): MediaItem[] {
  const result = list.filter((item) => {
    if (state.category !== "all" && item.category !== state.category) return false;
    if (state.region !== "all" && item.region !== state.region) return false;
    if (state.year !== "all" && item.year !== state.year) return false;
    return true;
  });

  if (state.sort === "newest") {
    return [...result].sort((a, b) => Number(b.year) - Number(a.year));
  }
  if (state.sort === "rating") {
    return [...result].sort((a, b) => Number(b.rating) - Number(a.rating));
  }
  return result;
}